type OnCameraStateChangeParams = {
  setIsCameraInside: React.Dispatch<React.SetStateAction<boolean>>;
  maxWaitMs?: number;   // скільки максимум чекати RoomManager (мс)
  intervalMs?: number;  // як часто перевіряти (мс)
};

export function onCameraStateChange({
  setIsCameraInside,
  maxWaitMs = 5000,
  intervalMs = 100,
}: OnCameraStateChangeParams) {
  // @ts-ignore
  const containerRef = window.containerRef as React.RefObject<HTMLIFrameElement>;

  if (!containerRef?.current?.contentWindow) {
    // console.warn('❗ Не знайдено iframe або contentWindow');
    return;
  }

  const canvasIframe = containerRef.current.contentWindow as any;
  const start = Date.now();

  const timerId = window.setInterval(() => {
    const rm = canvasIframe.RoomManager;

    // Коли RoomManager доступний і має метод onCameraStateChange — підписуємось
    if (rm && typeof rm?.onCameraStateChange === 'function') {
      window.clearInterval(timerId);

      rm?.onCameraStateChange((insideValue: boolean) => {
        setIsCameraInside(insideValue);

        // // опційний лог
        // if (insideValue) {
        //   console.log('✅ Камера ЗАЙШЛА в кімнату');
        // } else {
        //   console.log('🚪 Камера ВИЙШЛА з кімнати');
        // }
      });

      return;
    }

    // Якщо перевищили час очікування — відписуємось
    if (Date.now() - start > maxWaitMs) {
      window.clearInterval(timerId);
      // console.warn('⚠️ RoomManager не зʼявився в iframe за відведений час');
    }
  }, intervalMs);

  // Повертаємо cleanup на випадок, якщо захочеш зупинити очікування/підписку ззовні
  return () => {
    window.clearInterval(timerId);
  };
}
